<div class="hpanel margin-right-5" [ngClass]="communityStatus=='INACTIVE' ? 'hgreen' : 'hred'">
    <div class="panel-body">

        <!-- <span class="label label-danger pull-right" (ngclick)="deactivate()">Deactivate</span> -->
        <button *ngIf="communityStatus!='INACTIVE'" class="btn btn-danger pull-right" (click)="deactivate()">Deactivate</button>
        <button *ngIf="communityStatus=='INACTIVE'" class="btn btn-success pull-right" (click)="activate()">Activate</button>
        <!-- (click)="deactivate()" -->
        <div class="row">
            <div class="col-sm-8">
                <h4 class="banner-cls" data-toggle="tooltip" data-placement="top" title="{{communityName}}"><a   > {{ communityStatus=='INACTIVE' ? 'Activate' : 'Deactivate' }} </a> {{ communityName  }} </h4>



                <div class="row">
                    <!-- <div class="col-sm-3">
                        <div class="project-label">EMPLOYEES</div>
                        <small *ngIf="BusinessData.followersCnt > 0">{{BusinessData.employeesCnt}}</small>
                        <small *ngIf="BusinessData.followersCnt < 1">No EMPLOYEES</small>
                    </div>
                    <div class="col-sm-3">
                        <div class="project-label">FOLLOWERS</div>
                        <small *ngIf="BusinessData.followersCnt > 1">{{BusinessData.followersCnt}}</small>
                        <small *ngIf="BusinessData.followersCnt < 0">No followers</small>
                    </div> -->
                    <!-- <div class="col-sm-3">
                        <div class="project-label">COMMUNITY</div>
                        <small>26.02.2015</small>
                    </div>
                    <div class="col-sm-3">
                        <div class="project-label">POST JOBS</div>
                        <small>26.02.2015</small>
                    </div> -->
                </div>
            </div>

        </div>
    </div>
    <!-- <div class="panel-footer">
        Additional information about project in footer
    </div> -->
</div>
